import { render, staticRenderFns } from "./LichSuDichVuLuuTruForm.vue?vue&type=template&id=f7760be2&scoped=true"
import script from "./LichSuDichVuLuuTruForm.vue?vue&type=script&lang=js"
export * from "./LichSuDichVuLuuTruForm.vue?vue&type=script&lang=js"
import style0 from "./LichSuDichVuLuuTruForm.vue?vue&type=style&index=0&id=f7760be2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7760be2",
  null
  
)

export default component.exports